
import { useStore } from "vuex"
import { computed, defineComponent, ref } from "vue"
import { Inventory } from "@/data/Inventory";
import InventoryItem from "../../shared/InventoryMenu/InventoryItem.vue";
import GenericTabs from "../GenericTabs.vue";
import GearButton from "./GearButton.vue";
interface EquipPanelProps {
  gearSlot: string;
}
export default defineComponent({
  name: "EquipPanel",
  props: {
    gearSlot: {
      type: String,
      default: ''
    }
  },
  emits: [
    'equip',
    'resetView'
  ],
  components: { InventoryItem, GenericTabs, GearButton },
  setup(props: EquipPanelProps, context) {
    const store = useStore()
    const activeTab = ref('BASIC')
    const handleActiveTab = (tab) => {
      activeTab.value = tab.name
    }
    
    const resetView = () => {
      context.emit('equip')
      context.emit('resetView')
    }

    const tabs = computed(() => {
      return [
        {
          name: 'BASIC',
          selected: activeTab.value === 'BASIC'
        },
        {
          name: 'CRAFTED',
          selected: activeTab.value === 'CRAFTED'
        },
      ]
    })

    return {
      state: store.state,
      activeTab,
      handleActiveTab,
      items: Inventory[props.gearSlot],
      resetView,
      tabs,
    }
  },
})
